export function getLanguageLocally() : 'RU' | 'EN' {
    let language : string | null = localStorage.getItem('lang');
    return language === null || language === 'RU' ? 'RU' : 'EN';
}
export function storeLanguageLocally(lang: string) {
    return localStorage.setItem('lang', lang);
}